import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';

const EntityTagsPickerFieldSchema = makeFieldSchema({
  output: (z) => z.array(z.string()),
  uiOptions: (z) => z.object({
    kinds: z.array(z.string()).optional().describe("List of kinds of entities to derive tags from"),
    showCounts: z.boolean().optional().describe("Whether to show usage counts per tag"),
    helperText: z.string().optional().describe(
      "Helper text to display; DEPRECATED, simply use ui:description"
    )
  })
});
const EntityTagsPickerSchema = EntityTagsPickerFieldSchema.schema;

export { EntityTagsPickerFieldSchema, EntityTagsPickerSchema };
//# sourceMappingURL=schema.esm.js.map
